import { createSlice } from "@reduxjs/toolkit";
import { Part } from "../models/Part";

const PartsInitialState: {
	parts: Part[];
} = {
	parts: [],
};

export const PartsReducer = createSlice({
	name: "__",
	initialState: PartsInitialState,
	reducers: {
		setParts(state, { payload }) {
			state.parts = payload;
		},
	},
});
